module.exports = __webpack_public_path__ + "img/ascend_gold31.addc6300.png";